import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PreviewUserTeam {
  id?: string;
  name?: string;
  team_name?: string;
  role_name?: string;
  color?: string;
  [key: string]: unknown;
}

export interface PreviewUserMetadata {
  id: string;
  name: string;
  email?: string;
  teams?: PreviewUserTeam[];
  [key: string]: unknown;
}

export interface PreviewRoleMetadata {
  id: string;
  name: string;
}

export interface PreviewTeamMetadata {
  id: string;
  name: string;
}

export interface PreviewSliceState {
  previewUser: PreviewUserMetadata | null;
  previewRole: PreviewRoleMetadata | null;
  previewTeams: PreviewTeamMetadata[];
  shouldShowRolePreview: boolean;
}

const initialState: PreviewSliceState = {
  previewUser: null,
  previewRole: null,
  previewTeams: [],
  shouldShowRolePreview: false,
};

export const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    setPreviewUser: (
      state,
      action: PayloadAction<PreviewUserMetadata | null>
    ) => {
      state.previewUser = action.payload;
    },
    setPreviewRole: (
      state,
      action: PayloadAction<PreviewRoleMetadata | null>
    ) => {
      state.previewRole = action.payload;
    },
    setPreviewTeams: (state, action: PayloadAction<PreviewTeamMetadata[]>) => {
      state.previewTeams = action.payload;
    },
    setShouldShowRolePreview: (state, action: PayloadAction<boolean>) => {
      state.shouldShowRolePreview = action.payload;
    },
    resetPreviewState: (state) => {
      state.previewUser = null;
      state.previewRole = null;
      state.previewTeams = [];
      state.shouldShowRolePreview = false;
    },
  },
});

export const {
  setPreviewUser,
  setPreviewRole,
  setPreviewTeams,
  setShouldShowRolePreview,
  resetPreviewState,
} = previewSlice.actions;

export const previewReducer = previewSlice.reducer;
export default previewReducer;
